class ProductViewer extends HTMLElement {
    constructor() {
      super();
      this.splide_selector = `data-product-viewer-splide`;
      this.splide_containers = [...this.querySelectorAll(`[${this.splide_selector}]`)];
      this.splide_carousels = []
      this.button_selector = 'data-product-viewer-splide-tab';
      this.buttons = [...this.querySelectorAll(`[${this.button_selector}]`)];
      this.arrows = []
      this.active_index = 0
  
      if (window.Splide) {
        this.init();
      } else {
        document.getElementById('splide-script').addEventListener('load', this.init());
      }
  
      if (Shopify.designMode) {
        document.addEventListener('shopify:section:load', function (e) {
          const product_viewer = e.target.querySelector('product-viewer');
          if (product_viewer) product_viewer.init();
        });
  
        document.addEventListener('shopify:block:select', (e) => {
          const block_carousel = document.querySelector(`[data-block-id="${e.detail.blockId}"]`);
          if (block_carousel) {
            const product_viewer = block_carousel.closest('product-viewer');
            product_viewer.init();
            block_carousel.click();
          }
        });
  
        document.addEventListener('shopify:section:deselect', (e) => {
          const product_viewer = e.target.querySelector('product-viewer');
          if (product_viewer) product_viewer.init();
        });
      }
    }
  
    init() {
      const that = this
      this.splide_containers.forEach((e, i) => {
        const { dataset: {
          productViewerSplide: index
        } } = e;
        const splide = new Splide(e);
        splide.on('pagination:mounted', function (data) {
          data.list.classList.add('splide__pagination--custom');
        });
        splide.on( 'moved', function (e) {
          that.active_index = e
          that.handleOnMove(index);
        } );
        splide.mount();
        this.splide_carousels.push(splide)
        
        this.arrows = [...this.querySelectorAll(".splide__arrow")]
      });
      this.buttons.forEach((button) => {
        button.addEventListener('click', this.onButtonClick.bind(this));
      });
      this.arrows.forEach((arrow) => {
        arrow.addEventListener('click', this.handleOnMove.bind(this));
      });      
    }
  
    handleOnMove(index) {
      this.splide_carousels.forEach((carousel) => {
        const {
          root: 
          { dataset: {
          productViewerSplide: looped_index
        } }} = carousel;
        if(parseInt(looped_index) !== parseInt(index)) {
          carousel.go(this.active_index)
        }
      })
    }

    onButtonClick(event) {
      const button = event.target;
      const clicked_index = button.dataset.productViewerSplideTab;
      this.buttons.forEach((e, i) => {
        const button_index = e.dataset.productViewerSplideTab;
        if (clicked_index == button_index) e.classList.add('active');
        else e.classList.remove('active');
      });
      this.splide_carousels.forEach((carousel, i) => {
        const element = carousel.root
        const splide_index = element.dataset.productViewerSplide;
        if (clicked_index == splide_index) {
          element.classList.add('active-carousel');
        } else element.classList.remove('active-carousel');
      });
    }
  }
  
  if (!customElements.get('product-viewer')) customElements.define('product-viewer', ProductViewer);
  